/**
 * Constellation patterns for Career Constellation
 * Each constellation represents a combination of dominant domains
 */
const constellations = [
  {
    id: 'luminary',
    name: 'Luminary',
    domains: ['insight', 'vision'],
    description: 'The Luminary pattern brings insight and inspiration, lighting the way for others by combining analytical understanding with creative vision.',
    careerDirections: [
      'Research & Development',
      'Strategic Forecasting',
      'Educational Innovation',
      'Thought Leadership',
      'Innovation Research'
    ]
  },
  {
    id: 'trailblazer',
    name: 'Trailblazer',
    domains: ['vision', 'impact'],
    description: 'The Trailblazer pattern carves new paths others can follow by envisioning possibilities and mobilizing others toward meaningful transformation.',
    careerDirections: [
      'Change Leadership',
      'Innovation Management',
      'Creative Direction',
      'Entrepreneurship',
      'Business Transformation'
    ]
  },
  {
    id: 'spark',
    name: 'Spark',
    domains: ['connection', 'impact'],
    description: 'The Spark pattern ignites collaborative action by building bridges between people and ideas that lead to meaningful impact.',
    careerDirections: [
      'Community Building',
      'Relationship Management',
      'Team Development',
      'Business Development',
      'Strategic Partnerships'
    ]
  },
  {
    id: 'shaper',
    name: 'Shaper',
    domains: ['structure', 'vision'],
    description: 'The Shaper pattern designs and builds systems that bring creative visions to life through practical, sustainable implementation.',
    careerDirections: [
      'Systems Architecture',
      'Organizational Design',
      'Product Development',
      'Strategic Planning',
      'Experience Architecture'
    ]
  },
  {
    id: 'scholar',
    name: 'Scholar',
    domains: ['insight', 'structure'],
    description: 'The Scholar pattern understands complex situations through systematic analysis, uncovering patterns and insights that inform structured decisions.',
    careerDirections: [
      'Data Science & Analytics',
      'Business Intelligence',
      'Quality Assurance',
      'Research',
      'Strategy Consulting'
    ]
  },
  {
    id: 'storykeeper',
    name: 'Storykeeper',
    domains: ['connection', 'insight'],
    description: 'The Storykeeper pattern carries forward meaning and lessons by blending analytical insight with authentic connection and understanding.',
    careerDirections: [
      'Cross-cultural Communication',
      'Conflict Resolution',
      'Knowledge Brokering',
      'Coaching',
      'Human Resources'
    ]
  },
  {
    id: 'harborer',
    name: 'Harborer',
    domains: ['structure', 'connection'],
    description: 'The Harborer pattern provides steadiness and grounding for others by creating systems and environments where people can collaborate effectively.',
    careerDirections: [
      'Project Management',
      'Operations Leadership',
      'Event Coordination',
      'Team Development',
      'Process Facilitation'
    ]
  },
  {
    id: 'dreamweaver',
    name: 'Dreamweaver',
    domains: ['vision', 'connection'],
    description: 'The Dreamweaver pattern imagines futures through relationships and inspiration, weaving creative possibilities with human connection.',
    careerDirections: [
      'Creative Strategy',
      'Community Vision',
      'Collaborative Design',
      'Cultural Innovation',
      'Social Impact'
    ]
  },
  {
    id: 'navigator',
    name: 'Navigator',
    domains: ['insight', 'impact'],
    description: 'The Navigator pattern guides others through complex situations using analytical understanding and meaningful influence.',
    careerDirections: [
      'Advisory Services',
      'Knowledge Management',
      'Educational Leadership',
      'Management Consulting',
      'Organizational Transformation'
    ]
  },
  {
    id: 'anchor',
    name: 'Anchor',
    domains: ['impact', 'structure'],
    description: 'The Anchor pattern creates lasting change through grounded systems, providing stability while driving meaningful transformation.',
    careerDirections: [
      'Operations Strategy',
      'Change Management',
      'Systems Implementation',
      'Program Direction',
      'Implementation Consulting'
    ]
  }
];

// Helper function to get constellation by domains
const getConstellationByDomains = (domain1, domain2) => {
  return constellations.find(constellation => 
    (constellation.domains.includes(domain1) && constellation.domains.includes(domain2))
  );
};

// Add the helper function to the constellations object
constellations.getConstellationByDomains = getConstellationByDomains;

export default constellations; 
